
export default class CalendarLayout {

    constructor() {
        this.colIndex = 0;
        this.colCount = 1;
        this.colRatio = 1;
        this.rowOffset = 0;
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/components/calendar/model/calendar-layout.model.js